import { render, staticRenderFns } from "./PropagandistSchoolDetails.vue?vue&type=template&id=3141058a&"
import script from "./PropagandistSchoolDetails.vue?vue&type=script&lang=js&"
export * from "./PropagandistSchoolDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports